export const isServerError = errorStatus => Math.floor(errorStatus / 100) === 5;

export const isClientError = errorStatus => Math.floor(errorStatus / 100) === 4;
